var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import LoganOpensource from 'logan-web';
import Constants from './constants';
import GlobalConfigs from './global_configs';
import Cookie from './utils/cookie';
import { LogType } from './interface';
import { versionCompare, generateRandomBytes, getStringSize, getIntervalDays, consoleLoganIfSwitchIsOn, getLoganUnionId, InvokeByInterval } from './utils/common';
import Layers from './layers';
import Owl from './utils/owl';
import { ResultEnum, transOpensourceResultToReportResult, SingleReportResultEnum } from './utils/results';
import { dateFormat2Day } from './utils/common';
import { LogEncryptMode, ResultMsg } from 'logan-web/build/interface';
import Ajax from './utils/ajax';
var ES6Promise = require('es6-promise');
var PackageConfig = require('../package.json');
var SDKVersion = PackageConfig.version;
var reportInterval = new InvokeByInterval(1000);
if (!window.Promise) {
    window.Promise = ES6Promise;
}
var AsyncShakeInstance; // 异步加载并实例化的Shake对象
var AsyncEnv; // 异步加载的Env对象
var __version__ = SDKVersion;
var LoganInstance; // 全局唯一Logan实例
var config;
var log;
var logOnlyInBrowser;
var report;
var info;
var warn;
var error;
var showShakeLayer;
var hideShakeLayer;
var lastPreReportTime = Date.now(); // 上一次触发前置上报的时间
var preReportedTokens = []; // PRE_REPORT_THROTTLE_TIME时间段内触发前置上报的token，token是projectName、errorType及errorCategory拼接成的string
var sdkTimingReported = false; // 是否已经上报Logan SDK耗时数据
try {
    if (window.Logan && window.Logan.__version__ && versionCompare(window.Logan.__version__, __version__) >= 0) {
        // 已有全局的Logan版本不小于当前版本，则方法都指向原方法
        console.warn('当前页面已引入了一个高版本Logan，统一处理为高版本：' + window.Logan.__version__);
        var copyPropFromPrevLogan = function (propName) {
            return window.Logan[propName];
        };
        config = copyPropFromPrevLogan('config');
        log = copyPropFromPrevLogan('log');
        logOnlyInBrowser = copyPropFromPrevLogan('logOnlyInBrowser');
        report = copyPropFromPrevLogan('report');
        info = copyPropFromPrevLogan('info');
        warn = copyPropFromPrevLogan('warn');
        error = copyPropFromPrevLogan('error');
        showShakeLayer = copyPropFromPrevLogan('showShakeLayer');
        hideShakeLayer = copyPropFromPrevLogan('hideShakeLayer');
        __version__ = copyPropFromPrevLogan('__version__');
        LoganInstance = window.Logan;
    }
    else {
        var _getServerRequestPrefix_1 = function () {
            var _a, _b;
            if (GlobalConfigs.get('devMode')) {
                if (((_a = window.location) === null || _a === void 0 ? void 0 : _a.protocol) === 'http:' || ((_b = window.location) === null || _b === void 0 ? void 0 : _b.protocol) === 'https:') {
                    return "" + window.location.protocol + Constants.REPORT_PREFIX_BETA;
                }
                else {
                    return "http:" + Constants.REPORT_PREFIX_BETA;
                }
            }
            else {
                // 线上只允许https协议做接口请求
                return "https:" + Constants.REPORT_PREFIX_PROD;
            }
        };
        var _logLevelWrapper_1 = function (args) {
            return args.map(function (arg) {
                if (typeof arg === 'string') {
                    return arg;
                }
                else {
                    try {
                        if (arg instanceof Error) {
                            return JSON.stringify(arg, ['stack', 'message']);
                        }
                        else {
                            return JSON.stringify(arg);
                        }
                    }
                    catch (e) {
                        return arg.toString();
                    }
                }
            }).join(' ');
        };
        var _showReportLayer_1 = function () {
            Layers.showReportLayer(function (fromDateString, toDateString, reportConfig) {
                report(fromDateString, toDateString, reportConfig);
            });
        };
        var _toQueryString_1 = function (ob) {
            var queryArray = [];
            for (var property in ob) {
                queryArray.push(encodeURIComponent(property) + '=' + encodeURIComponent(ob[property]));
            }
            return queryArray.join('&');
        };
        var _reportTriggerListener_1 = function (e) {
            if (e.target === GlobalConfigs.get('reportTrigger')) {
                _showReportLayer_1();
            }
        };
        var _wrapReportResult_1 = function (fromDayString, toDayString, reportResult, universalErrorMsg) {
            var days = getIntervalDays(fromDayString, toDayString);
            var wrappedReportResult = days.reduce(function (acc, currentDay) {
                // 如果有统一的上报过程异常，比如不支持IDB等，就把统一的errorMsg塞入reportResult中
                if (universalErrorMsg) {
                    acc[currentDay] = {
                        code: SingleReportResultEnum.OTHER_ERROR.code,
                        msg: SingleReportResultEnum.OTHER_ERROR.msg,
                        desc: universalErrorMsg
                    };
                }
                else {
                    var openSourceResult = (reportResult || {})[currentDay];
                    // 将开源返回的report结果转译成内部的reportResult
                    var singleReportResult = transOpensourceResultToReportResult(openSourceResult === null || openSourceResult === void 0 ? void 0 : openSourceResult.msg, openSourceResult === null || openSourceResult === void 0 ? void 0 : openSourceResult.desc);
                    acc[currentDay] = singleReportResult;
                }
                return acc;
            }, {});
            return wrappedReportResult;
        };
        var _log_1 = function (logRawOb, logWay) {
            if (!logRawOb.logString) {
                consoleLoganIfSwitchIsOn('日志内容为空');
                return;
            }
            else if (getStringSize(logRawOb.logString) > Constants.MAX_SINGLE_LOG_SIZE) {
                consoleLoganIfSwitchIsOn("\u65E5\u5FD7\u5185\u5BB9\u5927\u5C0F\u8D85\u8FC7\u9650\u989D" + Constants.MAX_SINGLE_LOG_SIZE + " B, \u4E0D\u8FDB\u884C\u5B58\u50A8");
            }
            else {
                consoleLoganIfSwitchIsOn("[Logan]<\u65E5\u5FD7\u5185\u5BB9>" + logRawOb.logString);
            }
            var lowerCasedLogType = typeof logRawOb.logType === 'string' ? logRawOb.logType.toLocaleLowerCase() : undefined;
            var logTypeNumString = "" + (lowerCasedLogType && lowerCasedLogType in LogType ? LogType[lowerCasedLogType] : LogType.default);
            // 在浏览器存储容器中存储
            if (logWay.browser) {
                LoganOpensource.customLog({
                    logContent: JSON.stringify({
                        'f': logTypeNumString,
                        'c': encodeURIComponent(logRawOb.logString),
                        'd': Date.now(),
                        'l': Date.now(),
                        'm': 'true',
                        's': Cookie.get(Constants.COOKIENAME_SESSION_TOKEN) || Cookie.set(Constants.COOKIENAME_SESSION_TOKEN, generateRandomBytes(20)),
                        't': logRawOb.logLevel,
                        'g': logRawOb.tags instanceof Array ? logRawOb.tags.join('&') : (logRawOb.tags || '').toString()
                    }),
                    encryptVersion: LogEncryptMode.RSA
                });
            }
            // 通过桥接方式在native文件系统中存储
            if (logWay.bridge && !GlobalConfigs.get('disableKNB') && (AsyncEnv === null || AsyncEnv === void 0 ? void 0 : AsyncEnv.isValidApp)) {
                AsyncEnv.getKNB().sendMessage('sendLog', {
                    text: logRawOb.logString,
                    type: logTypeNumString,
                    time: +new Date(),
                    page: location.href
                }, {
                    success: function () {
                        // Noop
                    },
                    fail: function (err) {
                        Owl.asyncAddSDKError('KNB_SAVE_FAIL', err);
                    }
                }, 'logan');
            }
        };
        showShakeLayer = function () {
            Layers.showShakeLayer(function () {
                _showReportLayer_1();
            });
        };
        hideShakeLayer = function () {
            Layers.hideShakeLayer();
        };
        log = function (logString, logType, logLevel, tags) {
            _log_1({
                logString: logString,
                logType: logType,
                logLevel: logLevel,
                tags: tags
            }, {
                browser: true,
                bridge: true
            });
        };
        logOnlyInBrowser = function (logString, logType, logLevel, tags) {
            _log_1({
                logString: logString,
                logType: logType,
                logLevel: logLevel,
                tags: tags
            }, {
                browser: true,
                bridge: false
            });
        };
        info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            log(_logLevelWrapper_1(args), 'default', 'info');
        };
        warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            log(_logLevelWrapper_1(args), 'default', 'warn');
        };
        error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            log(_logLevelWrapper_1(args), 'default', 'error');
        };
        report = function (fromDateString, toDateString, config) { return __awaiter(void 0, void 0, void 0, function () {
            var fromDayString, toDayString, reportBaseQuery, onReportFinished, onReportFinishedByGlobal, onReportFinishedByCustom, startOfReport_1, reportResults_1, endOfReport, reportTimeCost, reportInfo_1, e_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        fromDayString = fromDateString || dateFormat2Day(new Date());
                        toDayString = toDateString || dateFormat2Day(new Date());
                        reportBaseQuery = {
                            webSource: (config === null || config === void 0 ? void 0 : config.webSource) || ((_a = AsyncEnv === null || AsyncEnv === void 0 ? void 0 : AsyncEnv.getUA()) === null || _a === void 0 ? void 0 : _a.type) || 'unknown',
                            unionId: (((config === null || config === void 0 ? void 0 : config.unionId) ? "" + config.unionId : undefined) || getLoganUnionId()).substring(0, Constants.UNIONID_LENGTH_MAX),
                            environment: ((config === null || config === void 0 ? void 0 : config.environment) || JSON.stringify((AsyncEnv === null || AsyncEnv === void 0 ? void 0 : AsyncEnv.getUA()) || {})).substring(0, Constants.ENV_LENGTH_MAX),
                            client: 'h5',
                            uploadSource: (config === null || config === void 0 ? void 0 : config.uploadSource) || 'bizReport',
                            customReportInfo: (typeof (config === null || config === void 0 ? void 0 : config.customReport) === 'string' ? config.customReport : JSON.stringify((config === null || config === void 0 ? void 0 : config.customReport) || GlobalConfigs.get('customReport') || {})).substring(0, Constants.CUSTOM_REPORT_LENGTH_MAX),
                            project: (config === null || config === void 0 ? void 0 : config.project) || Owl.getCurrentOwlProject() || 'unknown',
                            presubmitKey: (config === null || config === void 0 ? void 0 : config.preReportToken) || '',
                            presubmitTime: (config === null || config === void 0 ? void 0 : config.preReportClientTime) || ''
                        };
                        onReportFinishedByGlobal = typeof GlobalConfigs.get('onReportFinished') === 'function' ? GlobalConfigs.get('onReportFinished') : undefined;
                        onReportFinishedByCustom = typeof (config === null || config === void 0 ? void 0 : config.onReportFinished) === 'function' ? config.onReportFinished : undefined;
                        if (reportBaseQuery.uploadSource === 'userToast') {
                            onReportFinished = function (reportResults, reportQuery) {
                                onReportFinishedByCustom && onReportFinishedByCustom(reportResults, reportQuery);
                                return onReportFinishedByGlobal && onReportFinishedByGlobal(reportResults, reportQuery);
                            };
                        }
                        else {
                            onReportFinished = onReportFinishedByCustom || onReportFinishedByGlobal || (function () { });
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        if (!(!GlobalConfigs.get('devMode') && ((_b = window.location) === null || _b === void 0 ? void 0 : _b.protocol) === 'http:')) return [3 /*break*/, 2];
                        consoleLoganIfSwitchIsOn('非devMode的http协议，不触发日志上报');
                        onReportFinished(_wrapReportResult_1(fromDayString, toDayString, undefined, ResultEnum.INVALID_HTTP.msg), reportBaseQuery);
                        return [3 /*break*/, 4];
                    case 2:
                        startOfReport_1 = Date.now();
                        return [4 /*yield*/, reportInterval.call(function () {
                                startOfReport_1 = Date.now();
                                return LoganOpensource.report({
                                    fromDayString: fromDayString,
                                    toDayString: toDayString,
                                    xhrOptsFormatter: function (logItemString, logPageNo, logDayString) {
                                        var reportQuery = __assign(__assign({}, reportBaseQuery), { fileDate: logDayString, logArray: logItemString.toString(), logPageNo: logPageNo });
                                        return {
                                            reportUrl: "" + _getServerRequestPrefix_1() + Constants.REPORT_PATH,
                                            data: _toQueryString_1(reportQuery),
                                            headers: {
                                                'Content-Type': 'application/x-www-form-urlencoded',
                                                'Accept': 'application/json,text/javascript'
                                            }
                                        };
                                    },
                                    incrementalReport: true
                                });
                            })];
                    case 3:
                        reportResults_1 = _c.sent();
                        endOfReport = Date.now();
                        reportTimeCost = endOfReport - startOfReport_1;
                        reportInfo_1 = {
                            uploadSource: reportBaseQuery.uploadSource,
                            webSource: reportBaseQuery.webSource,
                            duringTime: reportTimeCost
                        };
                        // 打点上报结果
                        if (reportResults_1 && Object.keys(reportResults_1).length > 0) {
                            Object.keys(reportResults_1).forEach(function (day) {
                                var result = reportResults_1[day];
                                if (result.msg === ResultMsg.REPORT_LOG_SUCC) {
                                    Owl.asyncAddMetricInReportProcess(reportInfo_1);
                                    log("[Logan\u5185\u90E8\u65E5\u5FD7]\u4E0A\u62A5" + day + "\u8BE5\u5929\u65E5\u5FD7\u6210\u529F\uFF0CunionId\uFF1A" + reportBaseQuery.unionId);
                                }
                                else if (result.msg === ResultMsg.NO_LOG) {
                                    // 当天没有日志，无需打点
                                }
                                else if (result.msg === ResultMsg.REPORT_LOG_FAIL) {
                                    Owl.asyncAddMetricInReportProcess(reportInfo_1, 'REPORT_ERROR', result.desc);
                                }
                            });
                        }
                        else {
                            Owl.asyncAddMetricInReportProcess(reportInfo_1, 'REPORT_ERROR', 'reportResults are empty');
                        }
                        // 执行上报后的展示与回调
                        onReportFinished(_wrapReportResult_1(fromDayString, toDayString, reportResults_1), reportBaseQuery);
                        _c.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _c.sent();
                        onReportFinished(_wrapReportResult_1(fromDayString, toDayString, undefined, ResultEnum.DB_NOT_SUPPORT.msg), reportBaseQuery);
                        Owl.asyncAddMetricInReportProcess({
                            uploadSource: reportBaseQuery.uploadSource,
                            webSource: reportBaseQuery.webSource,
                            duringTime: 0
                        }, 'REPORT_ERROR', e_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        config = function (configOb) {
            if (!configOb || typeof configOb !== 'object') {
                return LoganInstance;
            }
            else {
                GlobalConfigs.set(configOb);
                if (configOb.disableShake === true) {
                    AsyncShakeInstance === null || AsyncShakeInstance === void 0 ? void 0 : AsyncShakeInstance.stop(); // 停止摇动监听
                }
                else if (configOb.disableShake === false) {
                    AsyncShakeInstance === null || AsyncShakeInstance === void 0 ? void 0 : AsyncShakeInstance.start(); // 开启摇动监听
                }
                if (configOb.reportTrigger) {
                    document && document.addEventListener('click', _reportTriggerListener_1);
                }
                else if (configOb.reportTrigger === null) {
                    document && document.removeEventListener('click', _reportTriggerListener_1);
                }
                // 统计SDK耗时放在config时机，原因在于这时候Owl大概率已经存在，且环境信息已经被配置了
                if (!sdkTimingReported) {
                    Owl.reportSDKLoadTiming(SDKVersion, [
                        "https:" + Constants.CDN_PREFIX_WITHOUT_PROTOCOL + "logan_" + SDKVersion + ".js",
                        "http:" + Constants.CDN_PREFIX_WITHOUT_PROTOCOL + "logan_" + SDKVersion + ".js"
                    ], !!GlobalConfigs.get('devMode'));
                    sdkTimingReported = true;
                }
                return LoganInstance;
            }
        };
        // 解析Owl日志
        var _parseOwlLog_1 = function (logOb, unionId) {
            var content = decodeURIComponent(logOb['c']);
            var owlErrorLogPre = '[Error]:';
            var owlApiLogPre = '[Ajax]:';
            try {
                // [Error]:开头的
                if (content.indexOf(owlErrorLogPre) === 0) {
                    var owlOb = JSON.parse(content.substring(owlErrorLogPre.length));
                    // Owl通过onerror，onunhandledrejection监听到的异常，或者业务使用addError包裹的jsError、ajaxError、resourceError或自定义异常
                    if ((owlOb === null || owlOb === void 0 ? void 0 : owlOb.sec_category) && owlOb.project && owlOb.timestamp) {
                        return {
                            projectName: owlOb.project,
                            errorType: owlOb.category || 'jsError',
                            errorCategory: owlOb.sec_category,
                            clientTime: owlOb.timestamp,
                            unionId: unionId
                        };
                    }
                    else {
                        return null;
                    }
                    // [Ajax]:开头的
                }
                else if (content.indexOf(owlApiLogPre) === 0) {
                    var owlOb = JSON.parse(content.substring(owlApiLogPre.length));
                    // AJAX异常时，error不为空
                    if ((owlOb === null || owlOb === void 0 ? void 0 : owlOb.error) && owlOb.project && owlOb.url && owlOb.timestamp) {
                        return {
                            projectName: owlOb.project,
                            errorType: 'ajaxError',
                            errorCategory: owlOb.url,
                            clientTime: owlOb.timestamp,
                            unionId: unionId
                        };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
            catch (error) {
                consoleLoganIfSwitchIsOn('Parse owl log item failed');
                return null;
            }
        };
        var _preReportIfNeed_1 = function (logItem) { return __awaiter(void 0, void 0, void 0, function () {
            var logOb, unionId, preReportQueryOb, preReportToken, preReportQueryResponse, responseOb, preReportTokenFromServer, e_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (Date.now() - lastPreReportTime > Constants.PRE_REPORT_THROTTLE_TIME) {
                            preReportedTokens = []; // 已超过前置上报节流时间限制，tokens重置
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        logOb = JSON.parse(logItem.logContent);
                        if (!(logOb['f'] === "" + LogType.owl)) return [3 /*break*/, 6];
                        if (!(!GlobalConfigs.get('devMode') && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.protocol) === 'http:')) return [3 /*break*/, 2];
                        // 如果非devMode下的http协议，则不再进行前置上报
                        consoleLoganIfSwitchIsOn('非devMode的http协议，不触发前置上报');
                        return [2 /*return*/];
                    case 2:
                        unionId = (Owl.getCurrentOwlUnionId() || '').substring(0, Constants.UNIONID_LENGTH_MAX);
                        preReportQueryOb = _parseOwlLog_1(logOb, unionId);
                        if (!preReportQueryOb) return [3 /*break*/, 6];
                        preReportToken = [preReportQueryOb.projectName, preReportQueryOb.errorType, preReportQueryOb.errorCategory].join('_');
                        if (!(preReportedTokens.indexOf(preReportToken) < 0)) return [3 /*break*/, 6];
                        lastPreReportTime = Date.now(); // 重置节流开始点
                        preReportedTokens = preReportedTokens.concat([preReportToken]);
                        return [4 /*yield*/, Ajax("" + _getServerRequestPrefix_1() + Constants.PRE_REPORT_QUERY, _toQueryString_1(preReportQueryOb), 'POST')];
                    case 3:
                        preReportQueryResponse = _b.sent();
                        responseOb = typeof preReportQueryResponse === 'object' ? preReportQueryResponse : JSON.parse(preReportQueryResponse);
                        if (!((responseOb === null || responseOb === void 0 ? void 0 : responseOb.code) === 200)) return [3 /*break*/, 5];
                        preReportTokenFromServer = responseOb.data;
                        // 发起前置上报
                        return [4 /*yield*/, report(null, null, {
                                unionId: unionId,
                                preReportToken: preReportTokenFromServer,
                                preReportClientTime: preReportQueryOb.clientTime,
                                uploadSource: 'preReport',
                                project: preReportQueryOb.projectName
                            })];
                    case 4:
                        // 发起前置上报
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        if ((responseOb === null || responseOb === void 0 ? void 0 : responseOb.code) === 600) {
                            // Noop，发生正常拦截，比如前置上报日志该小时内配额已满，或者该用户的该异常在一小时内已经报过了等
                        }
                        else if ((responseOb === null || responseOb === void 0 ? void 0 : responseOb.code) === 700) {
                            // 对黑名单内的问询进行拦截
                        }
                        else {
                            throw new Error("Server error, code: " + (responseOb === null || responseOb === void 0 ? void 0 : responseOb.code) + ", msg: " + (responseOb === null || responseOb === void 0 ? void 0 : responseOb.msg));
                        }
                        _b.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        e_2 = _b.sent();
                        Owl.asyncAddSDKError('PREREPORT_QUERY_ERROR', e_2);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        (function init() {
            var _this = this;
            // 引用logan时即刻埋下新的session token
            Cookie.set(Constants.COOKIENAME_SESSION_TOKEN, generateRandomBytes(20));
            // 展示摇一摇入口的后门
            if (location.href.indexOf('loganshake=1') >= 0) {
                showShakeLayer();
            }
            // 设置底层Logan配置
            LoganOpensource.initConfig({
                publicKey: Constants.PUBLIC_KEY,
                dbName: 'logan_web_2.0_db',
                errorHandler: function (e) {
                    switch (e && e.message) {
                        case ResultMsg.DB_NOT_SUPPORT:
                            Owl.asyncAddMetricInSaveProcess('DB_NOT_SUPPORT', e);
                            break;
                        case ResultMsg.EXCEED_LOG_SIZE_LIMIT:
                            Owl.asyncAddMetricInSaveProcess('EXCEED_DAY_LIMIT', e);
                            break;
                        case ResultMsg.EXCEED_TRY_TIMES:
                            // Noop
                            break;
                        default:
                            Owl.asyncAddMetricInSaveProcess('SAVE_LOG_FAIL', e);
                            break;
                    }
                },
                succHandler: function (logItem) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                Owl.asyncAddMetricInSaveProcess();
                                if (!!GlobalConfigs.get('disablePreReport')) return [3 /*break*/, 2];
                                return [4 /*yield*/, _preReportIfNeed_1(logItem)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); }
            });
            // 加载异步依赖
            import(/* webpackChunkName: "async_dependencies" */ './utils/async_dependencies').then(function (module) {
                var _a = (module === null || module === void 0 ? void 0 : module.default) || {}, Env = _a.Env, Shake = _a.Shake;
                AsyncEnv = Env;
                // 设置shake阈值
                AsyncShakeInstance = Shake && new Shake({
                    threshold: 15,
                    timeout: 1000
                });
                if (GlobalConfigs.get('disableShake') === false) {
                    AsyncShakeInstance === null || AsyncShakeInstance === void 0 ? void 0 : AsyncShakeInstance.start();
                }
                window.addEventListener('shake', function () {
                    if (!(AsyncEnv === null || AsyncEnv === void 0 ? void 0 : AsyncEnv.isValidApp) && !GlobalConfigs.get('disableShake')) {
                        // 在受Logan支持的App环境中不展示摇一摇侧栏，上报日志可以通过App上报
                        // 其他情况下都展示
                        showShakeLayer();
                    }
                }, false);
            }).catch(function (e) {
                consoleLoganIfSwitchIsOn("\u5F02\u6B65\u52A0\u8F7Dasync_dependencies\u5931\u8D25\uFF1A" + e);
            });
        })();
        LoganInstance = {
            log: log,
            logOnlyInBrowser: logOnlyInBrowser,
            config: config,
            report: report,
            info: info,
            warn: warn,
            error: error,
            showShakeLayer: showShakeLayer,
            hideShakeLayer: hideShakeLayer,
            __version__: __version__
        };
        window.Logan = LoganInstance;
    }
}
catch (e) {
    Owl.asyncAddSDKError('OTHER_ERROR', e);
}
export { log, logOnlyInBrowser, config, report, info, warn, error, showShakeLayer, hideShakeLayer, __version__ };
export default LoganInstance;
